package com.eladfinish.bible.contest.screens.main.verseWidgetSheet

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureDiscoverySheet
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetContent
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetDismissMethod
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetIntro
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetPoint
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetPreviewFrame
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetTitle
import com.eladfinish.bible.contest.verse_widget_sheet_cta
import com.eladfinish.bible.contest.verse_widget_sheet_footer
import com.eladfinish.bible.contest.verse_widget_sheet_intro
import com.eladfinish.bible.contest.verse_widget_sheet_point_rhythm_body
import com.eladfinish.bible.contest.verse_widget_sheet_point_rhythm_lead
import com.eladfinish.bible.contest.verse_widget_sheet_point_source_body
import com.eladfinish.bible.contest.verse_widget_sheet_point_source_lead
import com.eladfinish.bible.contest.verse_widget_sheet_point_tap_body
import com.eladfinish.bible.contest.verse_widget_sheet_point_tap_lead
import com.eladfinish.bible.contest.verse_widget_sheet_tag
import com.eladfinish.bible.contest.verse_widget_sheet_title

/**
 * The one-time "what's new" sheet of ווידג'ט פסוק מתחלף (the window and its closing are
 * [FeatureDiscoverySheet]). The button opens the widget's settings screen.
 *
 * The wording is a DRAFT: the final text is the owner's, word for word.
 */
@Composable
fun VerseWidgetSheet(
    onDismissed: (FeatureSheetDismissMethod) -> Unit,
    onCtaClicked: () -> Unit,
) {
    FeatureDiscoverySheet(onDismissed = onDismissed, onCtaClicked = onCtaClicked) { onClose, onCta ->
        VerseWidgetSheetContent(onClose = onClose, onCtaClicked = onCta)
    }
}

@Composable
fun VerseWidgetSheetContent(
    onClose: () -> Unit,
    onCtaClicked: () -> Unit,
    modifier: Modifier = Modifier,
) {
    FeatureSheetContent(
        tag = SharedRes.strings.verse_widget_sheet_tag,
        cta = SharedRes.strings.verse_widget_sheet_cta,
        footer = SharedRes.strings.verse_widget_sheet_footer,
        onClose = onClose,
        onCtaClicked = onCtaClicked,
        modifier = modifier,
    ) {
        FeatureSheetTitle(SharedRes.strings.verse_widget_sheet_title)
        FeatureSheetIntro(SharedRes.strings.verse_widget_sheet_intro)
        FeatureSheetPoint(
            lead = SharedRes.strings.verse_widget_sheet_point_source_lead,
            body = SharedRes.strings.verse_widget_sheet_point_source_body,
        )
        FeatureSheetPoint(
            lead = SharedRes.strings.verse_widget_sheet_point_rhythm_lead,
            body = SharedRes.strings.verse_widget_sheet_point_rhythm_body,
        )
        FeatureSheetPoint(
            lead = SharedRes.strings.verse_widget_sheet_point_tap_lead,
            body = SharedRes.strings.verse_widget_sheet_point_tap_body,
        )
    }
}

@Preview(showBackground = true, widthDp = 390, heightDp = 844, name = "Sheet — phone")
@Composable
private fun VerseWidgetSheetContentPreview() {
    FeatureSheetPreviewFrame {
        VerseWidgetSheetContent(onClose = {}, onCtaClicked = {})
    }
}

/** iPhone SE height: the text scrolls, the button stays on screen. */
@Preview(showBackground = true, widthDp = 320, heightDp = 480, name = "Sheet — small screen")
@Composable
private fun VerseWidgetSheetContentSmallPreview() {
    FeatureSheetPreviewFrame {
        VerseWidgetSheetContent(onClose = {}, onCtaClicked = {})
    }
}
